<div class="invoice-page fix-static-bug">
  <section class="invoice-layout-card">
  <section class="invoice-hero" aria-labelledby="organization-invoice-page-title">
    <h1 id="organization-invoice-page-title" class="title-text sam-page-heading">FAKTUROR ({{listLength}})</h1>
  </section>

  <div class="invoice-toolbar">
    <div class="toolbar-filters">
      <mat-form-field class="search-field" floatLabel="always" appearance="fill">
        <mat-label>Sök faktura</mat-label>
        <mat-icon matPrefix>search</mat-icon>
        <button
          mat-icon-button
          matSuffix
          type="button"
          *ngIf="search"
          (click)="search = ''; searchUpdate.next('')"
          aria-label="Rensa sök"
        >
          <mat-icon>close</mat-icon>
        </button>
        <input
          matInput
          [(ngModel)]="search"
          type="text"
          name="search"
          id="search"
          (ngModelChange)="searchUpdate.next($event)"
        />
      </mat-form-field>

      <mat-form-field class="status-filter-field" floatLabel="always" appearance="fill">
        <mat-label>Status</mat-label>
        <mat-select [ngModel]="selectedFilterStatus" [compareWith]="compareStatus" (ngModelChange)="filterStatusOnChange($event)">
          <mat-option *ngFor="let s of statuses" [value]="s">
            {{s?.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="invoice-table desktop-only">
    <div class="table-card mat-elevation-z1">
      <div *ngIf="isLoading" class="table-skeleton" aria-hidden="true">
        <div class="skeleton-row" *ngFor="let _ of [1,2,3,4,5]">
          <span class="skeleton-cell w-id"></span>
          <span class="skeleton-cell w-faktura"></span>
          <span class="skeleton-cell w-menu"></span>
          <span class="skeleton-cell w-date"></span>
          <span class="skeleton-cell w-date"></span>
          <span class="skeleton-cell w-user"></span>
          <span class="skeleton-cell w-customer"></span>
          <span class="skeleton-cell w-status"></span>
          <span class="skeleton-cell w-status"></span>
        </div>
      </div>

      <mat-table
        *ngIf="!isLoading"
        [dataSource]="dataSource"
        matSort
        (matSortChange)="sortData($event)"
        matSortActive="created"
        matSortDirection="asc"
        matSortDisableClear
      >
        <ng-container matColumnDef="file">
          <mat-header-cell *matHeaderCellDef mat-sort-header> </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <a
              *ngIf="row?.InvoiceDocument && row.Status.TechnicalName != 'UnderReview' && (row?.InvoiceDocument.Guid || row?.InvoiceDocument.Url)"
              href=""
              (click)="openInvoiceDocument(row?.InvoiceDocument, $event)"
              title="{{row?.InvoiceNumber}}"
            >
              <span class="invoice-file-icon" aria-hidden="true"><mat-icon>description</mat-icon></span>
            </a>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="icon">
          <mat-header-cell *matHeaderCellDef mat-sort-header> </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span *ngIf="row?.Type?.TechnicalName == 'ParentInvoice' || row?.ParentInvoice" class="groups">
              <mat-icon>groups</mat-icon>
            </span>
            <span
              *ngIf="row?.Type?.TechnicalName == 'CommissionCashInvoice'"
              class="groups"
              matTooltipPosition="after"
              area-label="Hover to display info"
              matTooltip="Detta är en kontantfaktura för provision."
            >
              <mat-icon>compare_arrows</mat-icon>
            </span>
            <span
              *ngIf="row?.Type?.TechnicalName == 'SubInvoice'"
              class="groups"
              matTooltipPosition="after"
              area-label="Hover to display info"
              matTooltip="Detta är underlag för utbetalning."
            >
              <mat-icon>person</mat-icon>
            </span>
          </mat-cell>
        </ng-container>

        <ng-container *ngIf="isAdmin" matColumnDef="invoicenumber">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Faktura </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <a
              *ngIf="row.InvoiceDocument && row.Status.TechnicalName != 'UnderReview' && (row?.InvoiceDocument.Guid || row?.InvoiceDocument.Url)"
              href=""
              (click)="openInvoiceDocument(row?.InvoiceDocument, $event)"
              title="{{row?.InvoiceNumber}}"
            >
              {{row?.InvoiceNumber}}
            </a>
            <span *ngIf="!row?.InvoiceDocument || row.Status.TechnicalName == 'UnderReview'">{{row?.InvoiceNumber}}</span>
          </mat-cell>
        </ng-container>

        <ng-container *ngIf="isAdmin" matColumnDef="id">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Id </mat-header-cell>
          <mat-cell *matCellDef="let row">{{row?.Id}}</mat-cell>
        </ng-container>

        <ng-container *ngIf="!isAdmin" matColumnDef="id">
          <mat-header-cell *matHeaderCellDef mat-sort-header> Faktura </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <a
              *ngIf="row.InvoiceDocument && row.Status.TechnicalName != 'UnderReview' && (row?.InvoiceDocument.Guid || row?.InvoiceDocument.Url)"
              href=""
              (click)="openInvoiceDocument(row?.InvoiceDocument, $event)"
              title="{{row?.InvoiceNumber}}"
            >
              {{row?.InvoiceNumber}}
            </a>
            <span *ngIf="!row?.InvoiceDocument || row.Status.TechnicalName == 'UnderReview'">{{row?.InvoiceNumber}}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="created">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Skickad</mat-header-cell>
          <mat-cell *matCellDef="let row">{{row?.InvoiceSentByUser | swedishDate:'yyyy-MM-dd'}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="dueDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Förfaller</mat-header-cell>
          <mat-cell *matCellDef="let row">{{row?.PaymentDue | swedishDate:'yyyy-MM-dd'}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="userName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Användare</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span>{{row?.UserSettings?.FirstName}} {{row?.UserSettings?.LastName}}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="customerName">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Kundnamn</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span *ngIf="row?.Customer?.Name != null">{{row?.Customer?.Name}}</span>
            <span *ngIf="row?.Customer?.Name == null && row?.RecieverCompanyName != null">{{row?.RecieverCompanyName}}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="payoutstatus">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Lönestatus</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span class="status-dot" [ngClass]="getStatusTone(row?.PayoutStatus?.TechnicalName, true)" aria-hidden="true"></span>
            <span *ngIf="!isAdmin">{{row?.PayoutStatus?.Name}}</span>
            <mat-select
              *ngIf="isAdmin"
              class="invoice-select"
              placeholder="Lönestatus"
              panelClass="invoice-select-panel"
              [(ngModel)]="row.PayoutStatus.Id"
              style="width: 130px;"
              (ngModelChange)="payoutStatusChange(row)"
            >
              <mat-option *ngFor="let s of payoutStatuses" [value]="s.Id">
                {{ s?.Name }}
              </mat-option>
            </mat-select>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="status">
          <mat-header-cell *matHeaderCellDef mat-sort-header>Fakturastatus</mat-header-cell>
          <mat-cell *matCellDef="let row">
            <span class="status-dot" [ngClass]="getStatusTone(row?.Status?.TechnicalName)" aria-hidden="true"></span>
            <span *ngIf="!isAdmin">{{row?.Status?.Name}}</span>
            <mat-select
              *ngIf="isAdmin"
              [disabled]="row?.SubInvoice"
              class="invoice-select"
              placeholder="Fakturastatus"
              panelClass="invoice-select-panel"
              [(ngModel)]="row.Status.Id"
              style="width: 145px;"
              (ngModelChange)="statusChange(row)"
            >
              <mat-option *ngFor="let s of statuses" [value]="s.Id">
                {{ s?.Name }}
              </mat-option>
            </mat-select>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="edit">
          <mat-header-cell *matHeaderCellDef class="options-header"></mat-header-cell>
          <mat-cell class="options" *matCellDef="let row">
            <button mat-icon-button class="menu-button" aria-label="Fakturaåtgärder" matTooltip="Fakturaåtgärder" [matMenuTriggerFor]="menu" disableRipple="true">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="editInvoice(row)">
                <mat-icon>edit</mat-icon>Redigera
              </button>
              <button *ngIf="isAdmin" mat-menu-item (click)="openAdminView(row)">
                <mat-icon>swap_horiz</mat-icon>Admin
              </button>
              <button *ngIf="isAdmin" mat-menu-item (click)="showSummary(row)">
                <mat-icon>money</mat-icon>In- och utbetalning
              </button>
              <button mat-menu-item (click)="creditInvoice(row)" [disabled]="isAdmin ? row?.InvoiceNumber == null : !checkMenuOption(row, 'credit')">
                <mat-icon>money_off</mat-icon>Kreditera
              </button>
              <button mat-menu-item *ngIf="isAdmin" (click)="openWorkCertificateView(row)" [disabled]="row?.PayoutStatus.TechnicalName != 'PaidOut'">
                <mat-icon>drafts</mat-icon>Arbetsgivarintyg
              </button>
              <button mat-menu-item (click)="copyInvoice(row)" [disabled]="row?.SubInvoice || row?.Status?.TechnicalName == 'Paired'">
                <mat-icon>file_copy</mat-icon>Kopiera till ny faktura
              </button>
              <button mat-menu-item (click)="deleteInvoice(row)" [disabled]="!canDeleteInvoice(row)">
                <mat-icon>delete</mat-icon>Radera
              </button>
            </mat-menu>
          </mat-cell>
        </ng-container>

        <mat-header-row
          *matHeaderRowDef="isAdmin ? ['file', 'icon', 'id', 'invoicenumber', 'edit', 'created', 'dueDate', 'userName', 'customerName', 'status', 'payoutstatus'] : ['file', 'icon', 'id', 'created', 'dueDate', 'userName', 'customerName', 'status', 'payoutstatus', 'edit']"
        ></mat-header-row>
        <mat-row
          *matRowDef="let row; columns: isAdmin ? ['file', 'icon', 'id', 'invoicenumber', 'edit', 'created', 'dueDate', 'userName', 'customerName', 'status', 'payoutstatus'] : ['file', 'icon', 'id', 'created', 'dueDate', 'userName', 'customerName', 'status', 'payoutstatus', 'edit']"
        ></mat-row>
      </mat-table>
    </div>
  </div>

  <div class="invoice-cards mobile-only">
    <mat-accordion>
      <mat-expansion-panel *ngFor="let row of (dataSource?.data || [])">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div class="panel-main">
              <div class="invoice-number">
                {{row?.InvoiceNumber}}
              </div>
              <div class="invoice-customer">
                {{ row?.Customer?.Name ? row.Customer.Name : row?.RecieverCompanyName }}
              </div>
            </div>
          </mat-panel-title>
          <mat-panel-description>
            <button
              mat-icon-button
              class="menu-button" aria-label="Fakturaåtgärder" matTooltip="Fakturaåtgärder"
              disableRipple="true"
              (click)="$event.stopPropagation()"
              (keydown)="$event.stopPropagation()"
              [matMenuTriggerFor]="menu"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="editInvoice(row)"><mat-icon>edit</mat-icon>Redigera</button>
              <button *ngIf="isAdmin" mat-menu-item (click)="openAdminView(row)"><mat-icon>swap_horiz</mat-icon>Admin</button>
              <button *ngIf="isAdmin" mat-menu-item (click)="showSummary(row)"><mat-icon>money</mat-icon>In- och utbetalning</button>
              <button mat-menu-item (click)="creditInvoice(row)" [disabled]="isAdmin ? row?.InvoiceNumber == null : !checkMenuOption(row, 'credit')">
                <mat-icon>money_off</mat-icon>Kreditera
              </button>
              <button mat-menu-item *ngIf="isAdmin" (click)="openWorkCertificateView(row)" [disabled]="row?.PayoutStatus.TechnicalName != 'PaidOut'">
                <mat-icon>drafts</mat-icon>Arbetsgivarintyg
              </button>
              <button mat-menu-item (click)="copyInvoice(row)" [disabled]="row?.SubInvoice || row?.Status?.TechnicalName == 'Paired'">
                <mat-icon>file_copy</mat-icon>Kopiera till ny faktura
              </button>
              <button mat-menu-item (click)="deleteInvoice(row)" [disabled]="!canDeleteInvoice(row)">
                <mat-icon>delete</mat-icon>Radera
              </button>
            </mat-menu>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div class="panel-body">
          <div class="field">
            <span class="label">Skickad</span>
            <span>{{row?.InvoiceSentByUser | swedishDate:'yyyy-MM-dd'}}</span>
          </div>
          <div class="field">
            <span class="label">Förfaller</span>
            <span>{{row?.PaymentDue | swedishDate:'yyyy-MM-dd'}}</span>
          </div>
          <div class="field" *ngIf="isAdmin">
            <span class="label">Användare</span>
            <span>{{row?.UserSettings?.FirstName}} {{row?.UserSettings?.LastName}}</span>
          </div>
          <div class="field">
            <span class="label">Fakturastatus</span>
            <span class="status-dot" [ngClass]="getStatusTone(row?.Status?.TechnicalName)" aria-hidden="true"></span>
            <span *ngIf="!isAdmin">{{row?.Status?.Name}}</span>
            <mat-select
              *ngIf="isAdmin"
              [disabled]="row?.SubInvoice"
              class="invoice-select"
              placeholder="Fakturastatus"
              panelClass="invoice-select-panel"
              [(ngModel)]="row.Status.Id"
              (ngModelChange)="statusChange(row)"
            >
              <mat-option *ngFor="let s of statuses" [value]="s.Id">
                {{ s?.Name }}
              </mat-option>
            </mat-select>
          </div>
          <div class="field">
            <span class="label">Lönestatus</span>
            <span class="status-dot" [ngClass]="getStatusTone(row?.PayoutStatus?.TechnicalName, true)" aria-hidden="true"></span>
            <span *ngIf="!isAdmin">{{row?.PayoutStatus?.Name}}</span>
            <mat-select
              *ngIf="isAdmin"
              class="invoice-select"
              placeholder="Lönestatus"
              panelClass="invoice-select-panel"
              [(ngModel)]="row.PayoutStatus.Id"
              (ngModelChange)="payoutStatusChange(row)"
            >
              <mat-option *ngFor="let s of payoutStatuses" [value]="s.Id">
                {{ s?.Name }}
              </mat-option>
            </mat-select>
          </div>
          <div class="field" *ngIf="row?.InvoiceDocument && row.Status.TechnicalName != 'UnderReview' && (row?.InvoiceDocument.Guid || row?.InvoiceDocument.Url)">
            <a href="" (click)="openInvoiceDocument(row?.InvoiceDocument, $event)" title="{{row?.InvoiceNumber}}">Se fakturan</a>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <div class="invoice-paginator">
    <mat-paginator
      [pageSizeOptions]="[25,50,100]"
      [pageSize]="10"
      [length]="listLength"
      (page)="onPaginatorChange($event)"
      showFirstLastButtons="true"
    ></mat-paginator>
  </div>
  </section>
</div>
